import type { Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';
import { yesNoOptionsWithNote } from './options';

// pre-carrier
export const step6: Fields = [
  {
    name: 'Voglio utilizzare il corriere di NGB Genetics',
    type: FieldTypes.radio,
    options: yesNoOptionsWithNote({
      yesNote: '(prenota il passaggio del corriere)',
      noNote: '(mi occuperò in autonomia della spedizione)',
    }),
    code: 88881,
    group: -1,
    note: 'Rispondendo "NO" il sistema salterà la fase di inserimento indirizzo per il corriere.',
    errors: ['required'],
  },
];
